import _styled, { default as _styled2, default as _styled3, default as _styled4, default as _styled5, default as _styled6, default as _styled7, default as _styled8 } from "styled-components";
var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6, _templateObject7;
function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
import React, { useRef } from 'react';
import { useImpressionRef } from '@noths/polaris-client-react-hooks';
import { toSentenceCase } from '@noths/polaris-client-utils';
import { LINK_CAROUSEL__CONTAINER_CLASS, LINK_CAROUSEL__HEADING_CLASS, LINK_CAROUSEL__LIST_CLASS } from "./constants";
import * as styles from "./styles";
import { useCarousel } from "./useCarousel";
import { PillButton } from "../../../elements/Button/PillButton/PillButton";
import { PillButtonLink } from "../../../elements/Button/PillButton/PillButtonLink";
import { ArrowButton } from "../../../elements/IconButtons/ArrowButton";
export var PillBarCarousel = function PillBarCarousel(_ref) {
  var items = _ref.items,
    onItemClick = _ref.onItemClick,
    onNavigateCarousel = _ref.onNavigateCarousel,
    onVisible = _ref.onVisible,
    title = _ref.title;
  var carouselWrapperRef = useImpressionRef(function () {
    return onVisible === null || onVisible === void 0 ? void 0 : onVisible();
  });
  var carouselItems = useRef([]);
  var _useCarousel = useCarousel(carouselWrapperRef, carouselItems, onNavigateCarousel),
    showNavigation = _useCarousel.hasNavigation,
    hasNext = _useCarousel.hasNext,
    hasPrevious = _useCarousel.hasPrevious,
    _onFocus = _useCarousel.onFocus,
    onNext = _useCarousel.onNext,
    onPrevious = _useCarousel.onPrevious,
    position = _useCarousel.position,
    xPosition = _useCarousel.xPosition;

  // iPhone fix for  as on iOS devices it is possible to "overscroll" past screen
  // so values become negative and the header intermittently disappears.
  var safeXPosition = xPosition < 0 ? 0 : xPosition;
  var createClickHandler = function createClickHandler(index) {
    return function (evt) {
      onItemClick === null || onItemClick === void 0 || onItemClick(evt, {
        index
      });
    };
  };
  return /*#__PURE__*/React.createElement(_StyledSection, {
    "aria-label": title,
    className: LINK_CAROUSEL__CONTAINER_CLASS,
    $_css: styles.linkCarousel
  }, /*#__PURE__*/React.createElement(_StyledH, {
    className: LINK_CAROUSEL__HEADING_CLASS,
    $_css2: styles.outsideCarouselHeading
  }, toSentenceCase(title)), /*#__PURE__*/React.createElement(_StyledDiv, {
    ref: carouselWrapperRef,
    $_css3: styles.carouselContentWrapper(showNavigation)
  }, /*#__PURE__*/React.createElement(_StyledDiv2, {
    style: {
      transform: "translateX(-".concat(position, "px)")
    },
    $_css4: styles.carouselContent
  }, /*#__PURE__*/React.createElement(_StyledH2, {
    /**
     * These 2 create curves for animation based on the carousels xPosition
     * 1 / 0 = infinity in JS land so they require isFinite checks..
     *  as Infinity !== valid css
     */
    className: LINK_CAROUSEL__HEADING_CLASS,
    style: {
      opacity: isFinite(1 / (safeXPosition / 20)) ? 1 / (safeXPosition / 20) : 1,
      transform: "scale(".concat(isFinite(1 / Math.exp(safeXPosition / 250)) ? 1 / Math.exp(safeXPosition / 250) : 1, ")")
    },
    $_css5: styles.inCarouselHeading
  }, title), /*#__PURE__*/React.createElement(_StyledUl, {
    className: LINK_CAROUSEL__LIST_CLASS,
    $_css6: styles.links
  }, items.map(function (item, index) {
    return /*#__PURE__*/React.createElement(_StyledLi, {
      key: "".concat(item.href, "-").concat(item.text),
      ref: function ref(el) {
        carouselItems.current[index] = el;
      },
      $_css7: styles.pill
    }, item.href ? /*#__PURE__*/React.createElement(PillButtonLink, {
      "data-active": Boolean(item.active),
      href: item.href,
      onClick: createClickHandler(index),
      onFocus: function onFocus(evt) {
        return _onFocus(evt.target);
      }
    }, item.text) : /*#__PURE__*/React.createElement(PillButton, {
      "data-active": Boolean(item.active),
      onClick: createClickHandler(index),
      onFocus: function onFocus(evt) {
        return _onFocus(evt.target);
      },
      type: "button"
    }, item.text));
  })))), showNavigation && /*#__PURE__*/React.createElement(_StyledDiv3, {
    "data-testid": "carousel-controls",
    $_css8: styles.carouselControls
  }, /*#__PURE__*/React.createElement(ArrowButton, {
    "aria-label": "Scroll to previous item",
    direction: "left",
    disabled: !hasPrevious,
    onClick: onPrevious,
    size: "small"
  }), /*#__PURE__*/React.createElement(ArrowButton, {
    "aria-label": "Scroll to next item",
    direction: "right",
    disabled: !hasNext,
    onClick: onNext,
    size: "small"
  })));
};
var _StyledSection = _styled("section")(_templateObject || (_templateObject = _taggedTemplateLiteral(["", ""])), function (p) {
  return p.$_css;
});
var _StyledH = _styled2("h3")(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["", ""])), function (p) {
  return p.$_css2;
});
var _StyledDiv = _styled3("div")(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["", ""])), function (p) {
  return p.$_css3;
});
var _StyledDiv2 = _styled4("div")(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["", ""])), function (p) {
  return p.$_css4;
});
var _StyledH2 = _styled5("h3")(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["", ""])), function (p) {
  return p.$_css5;
});
var _StyledUl = _styled6("ul")(_templateObject6 || (_templateObject6 = _taggedTemplateLiteral(["", ""])), function (p) {
  return p.$_css6;
});
var _StyledLi = _styled7("li")(_templateObject7 || (_templateObject7 = _taggedTemplateLiteral(["", ""])), function (p) {
  return p.$_css7;
});
var _StyledDiv3 = /*#__PURE__*/_styled8("div").withConfig({
  displayName: "PillBarCarousel___StyledDiv3",
  componentId: "sc-vrla-0"
})(["", ""], function (p) {
  return p.$_css8;
});